import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_ENDPOINT_STARTER;

const getDashboardData = async ()=> {
    return axios.get(API_URL + 'dashboard', { headers: await authHeader() });
  }

export{
    getDashboardData
}


